<template>
    <div class="panel-tech">
        <div class="index-container">
            <div class="index-title-group">
                <div class="index-title"><div>技术服务</div></div>
                <div class="index-title-sub">提供更多的保障，以增加成功的可能性，我们的服务旨在为客户提供无忧无虑的体验</div>
            </div>
            <div class="tech-row">
                <div class="tech-item">
                    <img src="../../resource/img/index/tech/1.png">
                    <div class="tech-item-title">私有部署</div>
                    <div class="tech-item-content">
                        <div>一次购买，终身使用</div>
                        <div>支持多种部署，更有掌控感</div>
                    </div>
                </div>
                <div class="tech-item">
                    <img src="../../resource/img/index/tech/2.png">
                    <div class="tech-item-title">快速启动</div>
                    <div class="tech-item-content">
                        <div>30分钟部署完毕</div>
                        <div>部门培训 快速应用</div>
                    </div>
                </div>
                <div class="tech-item">
                    <img src="../../resource/img/index/tech/3.png">
                    <div class="tech-item-title">高度扩展</div>
                    <div class="tech-item-content">
                        <div>便捷导入历史数据</div>
                        <div>智能连接多平台多终端</div>
                    </div>
                </div>
                <div class="tech-item">
                    <img src="../../resource/img/index/tech/4.png">
                    <div class="tech-item-title">不限使用期</div>
                    <div class="tech-item-content">
                        <div>一次购买 终身使用</div>
                        <div>无限使用 管理延续</div>
                    </div>
                </div>
            </div>
            <div class="tech-row">
                <div class="tech-item">
                    <img src="../../resource/img/index/tech/5.png">
                    <div class="tech-item-title">价格透明</div>
                    <div class="tech-item-content">
                        <div>价格公开透明</div>
                        <div>魔方式功能组合 购买更放心</div>
                    </div>
                </div>
                <div class="tech-item">
                    <img src="../../resource/img/index/tech/6.png">
                    <div class="tech-item-title">数据安全</div>
                    <div class="tech-item-content">
                        <div>128位智能加密措施</div>
                        <div>无限数据 IP行为追踪</div>
                    </div>
                </div>
                <div class="tech-item">
                    <img src="../../resource/img/index/tech/7.png">
                    <div class="tech-item-title">终身升级</div>
                    <div class="tech-item-content">
                        <div>一线需求 高频升级</div>
                        <div>严格贴合市场发展节奏</div>
                    </div>
                </div>
                <div class="tech-item">
                    <img src="../../resource/img/index/tech/8.png">
                    <div class="tech-item-title">7*12小时服务</div>
                    <div class="tech-item-content">
                        <div>强大服务团队</div>
                        <div>运维产品双服务 7*12小时客服</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "technology"
}
</script>

<style scoped>
.panel-tech {
    background: url("../../resource/img/index/tech/bg.jpg") no-repeat;
    background-size: 100% 100%;
    padding: 65px 0;
}

.tech-row {
    display: flex;
    justify-content: space-between;
    margin: 60px 80px;
}

.tech-item {
    width: 260px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.tech-item-title {
    font-size: 24px;
    font-weight: bolder;
    color: #141416;
    margin: 10px 0;
}

.tech-item-content {
    text-align: center;
    font-size: 18px;
    color: #545454;
}
</style>
